import dayjs from 'dayjs';
import type { RequestFn } from 'api/useApiRequest';

export const fetchTranscriptsEvents = (
  request: RequestFn,
  { isoDate, signal }: { isoDate: string | Date; signal?: AbortSignal }
) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/get-events?isoDate=${dayjs(isoDate).format('YYYY-MM-DD')}`,
    signal,
  });

export const fetchTranscriptsDebates = (
  request: RequestFn,
  { isoDate, signal }: { isoDate: string | Date; signal?: AbortSignal }
) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/get-debates?isoDate=${dayjs(isoDate).format('YYYY-MM-DD')}`,
    signal,
  });

export const createDiarisedTranscript = (
  request: RequestFn,
  { signal, ...data }: { signal?: AbortSignal; [key: string]: unknown }
) =>
  request({
    method: 'post',
    pathname: `/api/transcriber/create-diarised-transcript`,
    data,
    signal,
  });

export const updateDiarisedTranscript = (
  request: RequestFn,
  { signal, ...data }: { signal?: AbortSignal; [key: string]: unknown }
) =>
  request({
    method: 'post',
    pathname: `/api/transcriber/update-diarised-transcript`,
    data,
    signal,
  });

export const fetchListTranscripts = (
  request: RequestFn,
  { signal, ...params }: { signal?: AbortSignal; [key: string]: unknown }
) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/list-transcripts`,
    params,
    signal,
  });

export const fetchDownloadTranscript = (
  request: RequestFn,
  { id, signal }: { id: string | number; signal?: AbortSignal }
) =>
  request({
    method: 'get',
    pathname: `/api/transcriber/download-transcript`,
    params: { id },
    responseType: 'blob',
    signal,
  });

export const deleteTranscript = (
  request: RequestFn,
  { id, signal }: { id: string | number; signal?: AbortSignal }
) =>
  request({
    method: 'delete',
    pathname: `/api/transcriber/delete-transcript`,
    params: { id },
    signal,
  });
